module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/main-visual-text-0f6ba29820f270b1326b9ea5cf1cf2f3.svg";